var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 14.272C26.75 13.2648 26.6666 12.5298 26.4861 11.7676H14.75V16.3136H21.6388C21.5 17.4434 20.75 19.1448 19.0833 20.2881L19.0599 20.4403L22.7707 23.2574L23.0278 23.2826C25.3888 21.1456 26.75 18.0014 26.75 14.272Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7487 26.2499C18.1236 26.2499 20.9569 25.161 23.0264 23.2827L19.082 20.2881C18.0264 21.0095 16.6097 21.5131 14.7487 21.5131C11.4432 21.5131 8.63764 19.3762 7.63755 16.4226L7.49096 16.4348L3.63249 19.3612L3.58203 19.4987C5.63756 23.5004 9.85977 26.2499 14.7487 26.2499Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63883 16.4227C7.37495 15.6605 7.22223 14.8438 7.22223 13.9999C7.22223 13.156 7.37495 12.3394 7.62495 11.5771L7.61796 11.4148L3.71112 8.44141L3.5833 8.50099C2.73612 10.1616 2.25 12.0263 2.25 13.9999C2.25 15.9735 2.73612 17.8382 3.5833 19.4988L7.63883 16.4227Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7487 6.48663C17.0959 6.48663 18.6792 7.48024 19.5821 8.31057L23.1098 4.935C20.9432 2.96139 18.1237 1.75 14.7487 1.75C9.85981 1.75 5.63757 4.49942 3.58203 8.50106L7.62369 11.5772C8.63767 8.6236 11.4432 6.48663 14.7487 6.48663Z",
    fill: "#EB4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.98baad7b.svg";
export { ForwardRef as ReactComponent };